import { RequestStatus } from '../types';
import { SupportRequestStatusApi } from './apiTypes';

export const SUPPORT_REQUEST_STATUS_TO_UI: Record<
  SupportRequestStatusApi,
  RequestStatus
> = {
  NEW: 'New',
  IN_PROGRESS: 'In progress',
  RECEIVED: 'Received',
  RESOLVED: 'Resolved',
  REOPENED: 'Reopened',
  CANCELED: 'Canceled',
};

export const SUPPORT_REQUEST_STATUS_TO_API: Record<
  RequestStatus,
  SupportRequestStatusApi
> = {
  New: 'NEW',
  'In progress': 'IN_PROGRESS',
  Received: 'RECEIVED',
  Resolved: 'RESOLVED',
  Reopened: 'REOPENED',
  Canceled: 'CANCELED',
};

export const SUPPORT_REQUEST_STATUS_TRANSITIONS: Record<
  RequestStatus,
  RequestStatus[]
> = {
  New: ['In progress'],
  'In progress': ['Resolved', 'Canceled'],
  Resolved: ['Reopened'],
  Canceled: ['Reopened'],
  Reopened: ['In progress'],
  Received: [],
};

function isRequestStatus(value: string): value is RequestStatus {
  return Object.prototype.hasOwnProperty.call(
    SUPPORT_REQUEST_STATUS_TO_API,
    value,
  );
}

export function mapSupportStatusToApi(
  value: string,
): SupportRequestStatusApi | undefined {
  if (!isRequestStatus(value)) return undefined;
  return SUPPORT_REQUEST_STATUS_TO_API[value];
}
